import React from 'react'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

const RightArrow = () => {
	return <KeyboardArrowRightIcon />
}

export default RightArrow
